import { render } from "./Mange.vue?vue&type=template&id=637f0484"
import script from "./Mange.vue?vue&type=script&lang=js"
export * from "./Mange.vue?vue&type=script&lang=js"
script.render = render

export default script